// extracted by mini-css-extract-plugin
module.exports = {"tooltipPercent":"HarvestGraph_tooltipPercent__2b36U"};